interface Props { value: string; onChange: (v: string) => void; maxLength?: number }

export default function PinPad({ value, onChange, maxLength = 4 }: Props) {
    const press = (digit: string) => { if (value.length < maxLength) onChange(value + digit) }
    const backspace = () => onChange(value.slice(0, -1))

    const buttonClass = "bg-white border-2 border-capActive rounded-full text-4xl font-bold text-slate-700 active:bg-capActive-light active:scale-95 transition-all shadow-soft flex items-center justify-center select-none"

    return (
        <div className="grid grid-cols-3 gap-5 max-w-md mx-auto">
            {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map(d => (
                <button
                    key={d}
                    onClick={() => press(d)}
                    className={buttonClass}
                    style={{ width: "100%", aspectRatio: "1 / 1" }}
                >
                    {d}
                </button>
            ))}
            <div></div>
            <button
                onClick={() => press("0")}
                className={buttonClass}
                style={{ width: "100%", aspectRatio: "1 / 1" }}
            >0</button>
            <button
                onClick={backspace}
                className="bg-capInactive border-2 border-capActive rounded-full text-3xl font-bold text-slate-600 active:bg-capActive active:scale-95 transition-all shadow-soft flex items-center justify-center"
                style={{ width: "100%", aspectRatio: "1 / 1" }}
            >←</button>
        </div>
    )
}